import { render, staticRenderFns } from "./articleConfig.vue?vue&type=template&id=0b3706c2&scoped=true&"
import script from "./articleConfig.vue?vue&type=script&lang=js&"
export * from "./articleConfig.vue?vue&type=script&lang=js&"
import style0 from "./articleConfig.vue?vue&type=style&index=0&id=0b3706c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3706c2",
  null
  
)

export default component.exports